import { useRef } from "react";

export const FileUploader = ({ handleFile, buttonLabel = "Resume" }) => {
  // Create a reference to the hidden file input element
  const hiddenFileInput = useRef(null);

  // Programmatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };

  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      handleFile(false);
      return;
    }

    // Allowed MIME types
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ];

    if (!allowedTypes.includes(file.type)) {
      console.error("Unsupported file type");
      handleFile(false);
      return;
    }

    // Maximum file size: 10MB
    if (file.size > 10485760) {
      console.error("File size exceeds the 10MB limit");
      handleFile(false);
      return;
    }

    // Pass the valid file to the parent component
    handleFile(file);
  };

  return (
    <>
      <button className="btn-uploader" onClick={handleClick}>
        <i className="fa fa-upload"></i>&nbsp;{buttonLabel}&nbsp;
      </button>
      <input
        type="file"
        accept="image/jpeg,image/jpg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={handleChange}
        ref={hiddenFileInput}
        style={{ display: "none" }} // Make the file input element invisible
      />
    </>
  );
};

export default FileUploader;
